import { render, staticRenderFns } from "./mapf.vue?vue&type=template&id=5b42244a&scoped=true&"
import script from "./mapf.vue?vue&type=script&lang=js&"
export * from "./mapf.vue?vue&type=script&lang=js&"
import style0 from "./mapf.vue?vue&type=style&index=0&id=5b42244a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b42244a",
  null
  
)

export default component.exports